import React from 'react'
import { CheckboxLabel, FooterStyled, FormSection, Legend } from './PersonalDetails.styles'
import { AccountHeader } from '@mobi/component-library/Areas/Account'
import { AddressInput, CountrySelectField, Nationality } from '@mobi/account/Common'
import { Checkbox } from '@mobi/component-library/Selection&Input/Inputs'
import { InfoBox } from '@mobi/component-library/Feedback/InfoBox'
import { CustomerServiceEmail } from '@mobi/component-library/Base/Link'
import { useDispatch, useSelector } from 'react-redux'
import {
  getSignUpState,
  setIsManualAddressEntry,
  setShowPreviousAddress,
  setSignupApplication,
} from '../Store'
import { spacing } from '@mobi/component-library/Foundations'
import { Button } from '@mobi/component-library/Base/Buttons'
import { SignUpPageStyled } from './SignUpPage.styled'
import { StepGroup } from '@mobi/component-library/Base/StepGroup'
import { useNavigate } from 'react-router'
import { routes } from '../Utils'
import { signupTracker } from '@mobi/account/Common/Analytics'

export const LocationDetails = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const state = useSelector(getSignUpState)
  const application = state.signupApplication
  const [currentCountry, setCurrentCountry] = React.useState(Nationality.Australia)
  const [previousCountry, setPreviousCountry] = React.useState(Nationality.Australia)

  const isValidAddress =
    !!application.residentialAddress &&
    (!state.showPreviousAddress ||
      !!application.previousAddress ||
      previousCountry === Nationality.International)

  return (
    <SignUpPageStyled>
      <StepGroup currentStep={1} totalSteps={5} />
      <AccountHeader alignItems='start' title='Confirm your location' style={{ marginBottom: 0 }} />
      <FormSection>
        <CountrySelectField
          value={currentCountry}
          onChange={value => {
            setCurrentCountry(value)
            dispatch(
              setSignupApplication({
                ...application,
                residentialAddress: undefined,
              })
            )
          }}
        />
        {currentCountry === Nationality.Australia && (
          <>
            <AddressInput
              prefix='current-address'
              onValidationChange={change => {
                dispatch(
                  setSignupApplication({
                    ...application,
                    residentialAddress: change.isValid ? change.result : undefined,
                  })
                )
              }}
              onEntryModeChanged={mode => {
                dispatch(setIsManualAddressEntry(mode === 'Manual'))
              }}
            />
            <Checkbox
              id='sign-up-2-years'
              label={
                <CheckboxLabel>Have you lived at this address less than 2 years?</CheckboxLabel>
              }
              name='TwoYears'
              checked={state.showPreviousAddress}
              data-tid-sign-up-has-been-2-years=''
              onChange={e => {
                dispatch(setShowPreviousAddress(e.target.checked))
                dispatch(
                  setSignupApplication({
                    ...application,
                    previousAddress: undefined,
                  })
                )
                setPreviousCountry(Nationality.Australia)
              }}
            />

            {state.showPreviousAddress && (
              <>
                <Legend style={{ margin: `${spacing.sm} 0` }}>
                  <div>Previous Address</div>
                </Legend>
                <CountrySelectField
                  value={previousCountry}
                  onChange={value => {
                    setPreviousCountry(value)
                    dispatch(
                      setSignupApplication({
                        ...application,
                        previousAddress: undefined,
                      })
                    )
                  }}
                />
                {previousCountry !== Nationality.International && (
                  <AddressInput
                    prefix='previous-address'
                    onValidationChange={change => {
                      dispatch(
                        setSignupApplication({
                          ...application,
                          previousAddress: change.isValid ? change.result : undefined,
                        })
                      )
                    }}
                  />
                )}
              </>
            )}
          </>
        )}
        {currentCountry !== Nationality.Australia && (
          <InfoBox color='grey' size='md'>
            <span>Don't have an Australian address?</span>
            <div>
              We require an Australian residential address in order to progress your application.
              Please email us at <CustomerServiceEmail /> for assistance.
            </div>
          </InfoBox>
        )}
      </FormSection>
      <FooterStyled>
        {currentCountry === Nationality.Australia && (
          <Button
            type='button'
            isFullWidth
            disabled={!isValidAddress}
            onClick={() => {
              signupTracker({
                interaction_type: 'Confirm Address',
                signUpFlow: state.isVerificationAccount ? 'ID Verification' : 'Standard',
                addressMethod: state.isManualAddressEntry ? 'manual' : 'auto',
              })
              navigate(routes.contactDetails)
            }}
          >
            Next
          </Button>
        )}
      </FooterStyled>
    </SignUpPageStyled>
  )
}
